import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { Modal } from "../shared/modal";
import { ModalIcon } from "../shared/modal-icon";
import { ModalTitle } from "../shared/modal-title";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";

export type ModalOrderMinimumProduct = {
  id: string;
  name: string;
  orderMin: number;
};

type ModalOrderMinimumProps = {
  products: ModalOrderMinimumProduct[];
  onUpdateOrder: () => void;
  paymentReversed?: boolean;
};

export const ModalOrderMinimum = ({
  products,
  onUpdateOrder,
  paymentReversed = false
}: ModalOrderMinimumProps) => {
  return (
    <Modal backdropVariant="error" open>
      <div className="flex flex-col items-center gap-16 px-32 text-center">
        <ModalIcon icon={faExclamationTriangle} variant="error" />

        <ModalTitle size="8xl" variant="error" weight="black">
          <T _str="The following products have a minimum quantity which you have not reached." />
        </ModalTitle>

        <ul className="flex flex-col gap-4 text-6xl font-bold text-kiosk-text-white">
          {products.map((product) => (
            <li key={product.id} className="flex justify-between gap-16">
              <span>{product.name}</span>
              <span>
                <T _str="Minimum {minimum}" minimum={product.orderMin} />
              </span>
            </li>
          ))}
        </ul>

        {paymentReversed ? (
          <p className="text-6xl text-kiosk-text-white">
            <T _str="Your payment has been reversed automatically." />
          </p>
        ) : null}

        <ModalButtonGroup className="mt-16">
          <ModalButton variant="error" onClick={onUpdateOrder}>
            <T _str="Update order" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
